/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as AuthActions from '../store/auth.actions';
import { AuthState } from '../store/auth.state';

@Injectable()
export class UnauthorizedAccessInterceptor implements HttpInterceptor {
  constructor(private store: Store<AuthState>) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        catchError((error: any) => {
          if (error instanceof HttpErrorResponse && 401 === error.status) {
            this.store.dispatch(new AuthActions.Logout());
            return EMPTY;
          } else {
            return throwError(error);
          }
        })
      );
  }
}
